import { render, staticRenderFns } from "./Esatdo_asignaciones.vue?vue&type=template&id=04196b80"
import script from "./Esatdo_asignaciones.vue?vue&type=script&lang=js"
export * from "./Esatdo_asignaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports